import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

const API = process.env.REACT_APP_API_BASE || "https://petcare-production-5959.up.railway.app";

export default function AdminLogin() {
  const navigate = useNavigate();
//email and password store the input from the login form.
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleLogin(e) {
    // Prevent form submission from refreshing the page
    e.preventDefault();
   //// Reset previous errors
    setError("");

    //try {
      const res = await fetch(`${API}/admin/login`, {

        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
console.log(data);
      if (data.status !== "success") {
        setError(data.message || "Invalid details");
        return;
      }

      // Save token + admin info
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_info", JSON.stringify(data.admin));

      navigate("/admin"); // redirect to dashboard

    //} catch (err) {
      //setError("Server not responding");
   // }
  }

  return (
    <div className="admin-login-container">
      <form className="admin-login-box" onSubmit={handleLogin}>
        <h2>Admin Login</h2>

        {error && <div className="admin-error">{error}</div>}

        <div className="field">
          <label>Email</label>
          <input
            type="email"
            placeholder="admin@petcare.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="field">
          <label>Password</label>
          <input
            type="password"
            placeholder="••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button className="login-btn" type="submit">
          Login
        </button>
      </form>
    </div>
  );
}
